module.exports = __webpack_public_path__ + "img/icon-logout.e1755477.svg";